import { FileStorage } from './types';
import { getUploadUrls, uploadFile } from 'app/core/http';
import getContentTypeFromFile from 'app/shared/utils/getContentTypeFromFile';

export const S3: FileStorage = {
  upload(file, fileName, onProgress) {
    return new Promise(async (resolve, reject) => {
      try {
        const [contentType, getUploadUrlsResponse] = await Promise.all([
          getContentTypeFromFile(file),
          getUploadUrls([fileName])
        ]);

        const url = getUploadUrlsResponse.urls[0];

        await uploadFile(file, contentType, url, onProgress);

        resolve();
      } catch (error) {
        reject(error);
      }
    });
  }
};
